export default [
	// 充值列表
	{
		name: 'getMiZuanClist',
		url: '/v1/getMiZuanClist'
	},
	// H5支付-微信创建订单-汇付
	{
		name: 'h5wxpay',
		url: '/v1/v2/h5wxpay'
	},
	// H5支付-支付宝-汇付
	{
		name: 'h5alipay_huifu',
		url: '/v1/v2/h5alipay_huifu'
	},
	// 发送验证码
	{
		name: 'sendCode',
		url: '/v1/sendCode'
	},
	// h5注册
	{
		name: 'h5zhuce',
		url: '/v1/h5zhuce'
	}
]